import type { CharacterType } from "../model/types"

export const characterKeys = {
	all: ["characters"] as const,
	lastMessage: (character: CharacterType, userId: number) =>
		[...characterKeys.all, "last-message", character, userId] as const,
	update: () => [...characterKeys.all, "update"] as const,
} as const
